import React from 'react'
import insta from '../../images/Footer/instagram.svg'
import twitter from '../../images/Footer/twitter-square.svg'
import Footerstyles from './footer.module.css'
import hustlemad from '../../images/Footer/logo-dark-blue.svg'
import line from '../../images/Footer/footer-line.svg'

function footer() {
  return (
    <div className={Footerstyles.footer}>
      <div className={Footerstyles.contentFooter}>
        <div className={Footerstyles.topFooterContainer}>
          <div className={Footerstyles.imageContainer}>
            <img src={hustlemad} alt='hustlemad' />
            <img src={line} alt='line' />
            <div className={Footerstyles.basedIn}>Based in Bengaluru ❤️</div>
          </div>
          <div className={Footerstyles.linksContainer}>
            {FooterLinks.map((link) => (
              <div key={link.title} className={Footerstyles.linkContainer}>
                <p className={Footerstyles.footerLinksTitle}>{link.title}</p>
                <div className={Footerstyles.links}>
                  {link.children.map((child) => (
                    <a
                      key={child.title}
                      href={child.link}
                      className={Footerstyles.footerLink}
                    >
                      {child.title}
                    </a>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
        <hr className={Footerstyles.lineFooter} />
        <div className={Footerstyles.writingFooter}>
          <div className={Footerstyles.leftFooter}>
            <p>Follow along on our Journey!</p>
          </div>
          <div className={Footerstyles.rightFooter}>
            <div>
              <a href='https://twitter.com/hustlemad_' target='_blank'>
                <img src={twitter} alt='' />
              </a>
              <a href='https://www.instagram.com/hustlemad/' target='_blank'>
                <img src={insta} alt='' />
              </a>
              <a
                href='https://www.linkedin.com/company/hustlemad'
                target='_blank'
                rel='noopener noreferrer'
              >
                <svg
                  width='16px'
                  height='16px'
                  viewBox='0 0 24 24'
                  fill='currentColor'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path d='M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z' />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default footer

const FooterLinks = [
  {
    title: 'Company',
    children: [
      {
        title: 'Build a Box',
        link: '/catalogue',
      },
      {
        title: 'Blogs',
        link: '/blogs',
      },
      {
        title: 'About Us',
        link: '/ourstory',
      },
      {
        title: 'FAQs',
        link: '/faq',
      },
    ],
  },
  {
    title: 'Contact',
    children: [
      {
        title: 'Schedule a Call',
        link: 'https://zcal.co/i/y3a0AYqZ',
      },
      {
        title: 'Be our Partner',
        link: '/partner',
      },
      {
        title: 'Contact Us',
        link: '/contact',
      },
    ],
  },
  {
    title: 'Legal',
    children: [
      {
        title: 'Privacy Policy',
        link: '/privacy-policy',
      },
      {
        title: 'Terms of Service',
        link: '/terms-of-service',
      },
    ],
  },
]
